module.exports = __webpack_public_path__ + "static/the-palm-at-the-end-of-the-mind-e2f022731cc600673c8cf331a4a0fc9f.jpg";